module.exports = new __parcel__URL__("swiftnourishment.0d5188a2.png").toString();